import { render, staticRenderFns } from "./ScrollIncitator.vue?vue&type=template&id=0026c654&scoped=true&"
import script from "./ScrollIncitator.vue?vue&type=script&lang=js&"
export * from "./ScrollIncitator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollIncitator.vue?vue&type=style&index=0&id=0026c654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026c654",
  null
  
)

export default component.exports